module.exports = require('./helpers/bundle-url').getBundleURL('aqzUD') + "logo.c51670a8.svg";